import { ContainerModule } from 'inversify';
import DITypes from './types';
import type { IDispatcher, IDispatcherFactory, IAdapterFactory } from './interfaces';
import { DispatcherFactory } from '../DispatcherFactory';
import AdapterFactory from '@framework/di/Providers/Rpc/AdapterFactory';

export const DispatcherModule = new ContainerModule(({ bind }) => {
  bind<IAdapterFactory>(DITypes.AdapterFactory).to(AdapterFactory).inSingletonScope();

  bind<IDispatcherFactory>(DITypes.DispatcherFactory).to(DispatcherFactory).inSingletonScope();

  bind<IDispatcher>(DITypes.JsonRpcDispatcher).toDynamicValue(({ get }) => (
    get<IDispatcherFactory>(DITypes.DispatcherFactory).create()
  )).inSingletonScope();
});
